// A brand saved with a Google font first gets its typography from the worker a few seconds
// later (spec G15b-brand-typography), after its page has opened: the page reads the brand again
// while it waits, for a minute at most, as no stream event names a brand.
import type { Brand } from "../../api/generated/model";

/** How often the page reads the brand again while its typography is on its way. */
export const TYPOGRAPHY_POLL_MS = 3_000;
/** How long after the page opened it waits: a classification takes seconds, a failed one never. */
export const TYPOGRAPHY_WAIT_MS = 60_000;

/**
 * Whether the page still waits for the brand's typography: its first font is a Google font, it
 * has no typography yet, and the page opened less than the wait ago.
 */
export function awaitingTypography(
  brand: Brand | undefined,
  openedAt: number,
  now: number = Date.now(),
): boolean {
  if (brand === undefined || brand.typography !== null) return false;
  return brand.fonts[0]?.source === "google" && now - openedAt < TYPOGRAPHY_WAIT_MS;
}
